<template>
<v-layout v-bind="layout">
	<v-flex xs6>
		<v-text-field
		v-model="search"
		append-icon="fa-search"
		label="Search"
		single-line
		hide-details>
		</v-text-field>
	</v-flex>
	<v-spacer></v-spacer>
	<v-flex xs5>
		<v-select
		v-model="states"
		:items="stateOptions"
		label="State"
		multiple
		></v-select>
	</v-flex>
</v-layout>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'

export default {
	name: "JmFilterJourney",

	props: {
		entities: Array
	},

	data () {
		return {
			stateOptions: [
				{ text: "Planned", value: "pending" },
				{ text: "In progress", value: "ongoing" },
				{ text: "Recent", value: "recent" },
				{ text: "Completed", value: "completed" },
				{ text: "Inactive", value: "inactive" }
			],
			search: "",
			states: [ "pending", "ongoing", "recent" ],
			isDirty: false,
			isFiltering: false,
			filteredEntities: []
		}
	},

	watch: {

		search () {
			this.isDirty = true;
			this.applyFiltersDebounced();
		},

		states () {
			this.isDirty = true;
			this.applyFiltersDebounced();
		},

		entities () {
			this.applyFilters();
		},

		filteredEntities () {
			this.$emit('filtered', this.filteredEntities);
		}
	},

	computed: {

		layout () {
			const layout = {};

			if (this.$vuetify.breakpoint.mdAndUp) {
				layout.row = true;
			} else {
				layout.column = true;
			}

			return layout;
		}

	},

	methods: {

		applyFilters () {
			let entities = [];

			if (this.states.length) {
				for (let entity of this.entities) {
					const state = entity.status && entity.status({});
					const isActive = entity.data.state != 'inactive';

					if (isActive || this.states.includes("inactive")) {

						switch (state) {
							case "detresfa":
							case "alerfa":
								entities.push(entity);
								break;
							case "completed":
								if (this.states.includes("completed")) {
									entities.push(entity);
								} else if (this.states.includes("recent")) {
									if ((moment() - moment(entity.updatedOn)) < 2*3600*1000) {
										entities.push(entity);
									}
								}
								break;
							case "pending":
							case "inactive":
								if (this.states.includes("pending")) {
									entities.push(entity);
								}
								break;
						}

					}
				}
			}

			if (this.search.trim()) {
				const rx = this.search.match(/^\/(.*)\/(.*)$/);
				const search = rx
					? new RegExp(rx[1], rx[2])
					: new RegExp(this.search, "i");

				entities = entities.filter(e => e.match(search));
			}

			this.filteredEntities = entities;
			return entities;
		},

		applyFiltersDebounced: _.debounce( function () {
			this.isFiltering = true;
			this.applyFilters();
			this.isFiltering = false;
			this.isDirty = false;
		}, 350)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/FilterWidgets/Journey.vue